const faqs = [
  {
    question: '韩国漫画网是完全免费的吗？',
    answer: '是的，韩国漫画网提供的所有韩漫内容均为免费阅读。我们致力于为广大漫画爱好者提供无门槛的优质韩国漫画阅读体验，无需注册会员即可畅享全部内容。我们通过广告合作来维持网站运营，确保每位读者都能免费获取最新最全的韩漫资源。',
  },
  {
    question: '网站更新频率是怎样的？',
    answer: '我们每天都会同步更新最新的韩漫章节，确保读者可以第一时间阅读到最新的漫画内容。热门连载作品通常每日更新一话，部分作品会根据韩国原版更新节奏同步发布。您可以通过"最近更新"板块随时掌握最新动态。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '我们提供了多种方式帮助您快速找到想看的漫画：您可以通过首页的"漫画分类"板块按类型浏览（爱情、奇幻、动作、悬疑、喜剧、校园、都市、古风），也可以使用"热门推荐"发现大家都在看的作品，或者在"最近更新"中查看最新发布的漫画。未来我们还将上线搜索功能。',
  },
  {
    question: '网站支持手机阅读吗？',
    answer: '当然支持！韩国漫画网采用了响应式设计，完美适配手机、平板和电脑等各类设备。无论您是在通勤路上还是在家中休息，都能获得舒适的漫画阅读体验。我们建议使用主流浏览器（Chrome、Safari、Edge等）访问以获得最佳效果。',
  },
  {
    question: '漫画的画质如何？',
    answer: '我们采用高清图像传输技术，确保每一页漫画都清晰可见。所有韩漫内容均为原版高清画质，支持放大查看细节。同时我们针对不同网络环境进行了加载优化，在保证画质的前提下提供流畅的浏览体验。',
  },
];

export default function FAQSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于韩国漫画网的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h4 className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-8">
                  {faq.question}
                </h4>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:bg-primary-100 transition-colors">
                  <i className="ri-add-line text-xs text-foreground-600 group-open:hidden"></i>
                  <i className="ri-subtract-line text-xs text-primary-600 hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}